// Exports
export default {
	"NameWrapper": "NameWrapper_m54f1",
	"Name": "Name_87gi-",
	"pulse": "pulse_oJyhY",
	"TextName": "TextName_BOaIg",
	"ModerationControlButton": "ModerationControlButton_5pq6W",
	"ModerationButtonIcon": "ModerationButtonIcon_uicmp",
	"MicroOffIcon": "MicroOffIcon_qtQJ7",
	"ParticipantMoreButton": "ParticipantMoreButton_PmL-d"
};
